import { useEffect, useRef, useState } from 'react'
import { api } from '../lib/api.js'
import { confirmBox, alertBox } from '../components/Dialog.jsx'
import { serverUrl } from '../platform/server.js'
import { DocumentCard } from '../components/Media.jsx'
import { DOCUMENT_ACCEPT, libraryFileType, documentDownloadName } from '../lib/documentUpload.js'

const TABS = [
  { key: 'faq', label: '问答话术' },
  { key: 'media', label: '素材库' },
  { key: 'docs', label: 'Skill 文档' },
]

export default function Knowledge() {
  const [tab, setTab] = useState('faq')
  return (
    <div style={{ padding: '28px 32px', maxWidth: 1100 }}>
      <div style={{ fontSize: 20, fontWeight: 600 }}>知识库</div>
      <div className="muted small" style={{ marginTop: 4, marginBottom: 20 }}>
        AI 回复客户时会参考这里的全部话术；图片、视频及 Word / PDF 文件供客服在工作台一键发送
      </div>
      <div className="row" style={{ gap: 6, marginBottom: 18 }}>
        {TABS.map(t => (
          <button key={t.key} className="btn btn-sm" onClick={() => setTab(t.key)}
            style={t.key === tab ? { background: 'var(--brand)', borderColor: 'var(--brand)', color: '#fff' } : {}}>
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'faq' ? <Faqs /> : tab === 'media' ? <Media /> : <SkillDocs />}
    </div>
  )
}

// ============ 问答话术 ============
const FAQ_PRESET_CATEGORIES = [
  '车牌与资质', '办理流程', '权益金与360元', '加油洗车金',
  '价格与收费异议', '产品选择与让步', '设备使用与故障', '售后与其他',
]

function Faqs() {
  const [list, setList] = useState([])
  const [q, setQ] = useState('')
  const [activeCat, setActiveCat] = useState('')
  const [editing, setEditing] = useState(null)
  const [err, setErr] = useState('')

  const load = () => api.listFaqs({ limit: 500 }).then(setList).catch(e => setErr(e.message))
  useEffect(() => { load() }, [])

  const categories = [...new Set([...FAQ_PRESET_CATEGORIES, ...list.map(f => f.category).filter(Boolean)])]
  const counts = list.reduce((a, f) => ({ ...a, [f.category || '未分类']: (a[f.category || '未分类'] || 0) + 1 }), {})

  const shown = list.filter(f => {
    const s = q.trim().toLowerCase()
    const matchQ = !s || (f.question || '').toLowerCase().includes(s) || (f.answer || '').toLowerCase().includes(s)
    const matchCat = !activeCat || (f.category || '未分类') === activeCat
    return matchQ && matchCat
  })

  async function del(f) {
    if (!(await confirmBox(`确认删除这条话术？\n\n${f.question}`))) return
    try { await api.deleteFaq(f.id); load() } catch (e) { alertBox('删除失败：' + e.message) }
  }

  async function move(f, category) {
    try { await api.upsertFaq({ ...f, category }); load() } catch (e) { alertBox(e.message) }
  }

  return (
    <div className="card" style={{ padding: 20 }}>
      <div className="spread" style={{ marginBottom: 14 }}>
        <div className="row">
          <strong>问答话术</strong>
          <span className="tag">{list.length} 条</span>
        </div>
        <div className="row" style={{ gap: 8 }}>
          <input className="input" style={{ width: 200 }} value={q} onChange={e => setQ(e.target.value)}
            placeholder="搜索问题或答案" />
          <button className="btn btn-primary btn-sm" onClick={() => setEditing({ category: activeCat || FAQ_PRESET_CATEGORIES[0] })}>+ 新增话术</button>
        </div>
      </div>
      <div className="row" style={{ gap: 6, flexWrap: 'wrap', marginBottom: 14 }}>
        <button className="btn btn-sm" onClick={() => setActiveCat('')}
          style={!activeCat ? { background: 'var(--brand)', borderColor: 'var(--brand)', color: '#fff' } : {}}>
          全部 {list.length}
        </button>
        {categories.sort((a, b) => a === '未分类' ? 1 : b === '未分类' ? -1 : 0).map(c => (
          <button key={c} className="btn btn-sm" onClick={() => setActiveCat(c)}
            style={activeCat === c ? { background: 'var(--brand)', borderColor: 'var(--brand)', color: '#fff' } : {}}>
            {c} {counts[c] || 0}
          </button>
        ))}
      </div>
      {err && <div className="err">{err}</div>}

      {shown.length === 0 ? (
        <div className="empty">{q ? '没有匹配的话术' : '暂无话术'}</div>
      ) : (
        <div>
          {shown.map(f => (
            <div key={f.id} style={{ padding: '14px 0', borderTop: '1px solid var(--line)' }}>
              <div className="spread" style={{ alignItems: 'flex-start', gap: 12 }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 500, marginBottom: 5 }}>
                    Q：{f.question}
                    {f.block && <span className="tag" style={{ marginLeft: 8 }}>{f.block}</span>}{f.voice && <span className="tag" style={{ marginLeft: 8 }}>语音回复</span>}
                  </div>
                  <div className="muted" style={{ whiteSpace: 'pre-wrap', fontSize: 13, lineHeight: 1.6 }}>
                    A：{f.answer}
                  </div>
                  {f.channel_scope?.length > 0 && (
                    <div className="row" style={{ gap: 5, marginTop: 6 }}>
                      {f.channel_scope.map(c => <span key={c} className="tag">{c}</span>)}
                    </div>
                  )}
                </div>
                <div className="row" style={{ gap: 4, flexShrink: 0, alignItems: 'center' }}>
                  <select className="input" style={{ width: 130 }} value={f.category || ''}
                    onChange={e => move(f, e.target.value)}>
                    <option value="">未分类</option>
                    {categories.filter(c => c !== '未分类').map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                  <button className="btn-link" onClick={() => setEditing(f)}>编辑</button>
                  <button className="btn-link" style={{ color: 'var(--danger)' }} onClick={() => del(f)}>删除</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      {editing && <FaqModal faq={editing} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); load() }} />}
    </div>
  )
}

function FaqModal({ faq, onClose, onSaved }) {
  const [f, setF] = useState({ question: faq.question || '', answer: faq.answer || '', category: faq.category || '', voice: !!faq.voice })
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  async function save() {
    if (!f.question.trim() || !f.answer.trim()) return setErr('问题和答案都要填')
    setBusy(true)
    try {
      await api.upsertFaq({ id: faq.id, question: f.question.trim(), answer: f.answer.trim(), category: f.category || null, enabled: true, voice: f.voice })
      onSaved()
    } catch (e) { setErr(e.message); setBusy(false) }
  }

  return (
    <div className="modal-bg" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={{ maxWidth: 600 }}>
        <h2>{faq.id ? '编辑话术' : '新增话术'}</h2>
        <div className="field">
          <label>分类</label>
          <select className="input" value={f.category} onChange={e => setF({ ...f, category: e.target.value })}>
            <option value="">未分类</option>
            {FAQ_PRESET_CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
        <div className="field">
          <label>客户会怎么问</label>
          <input className="input" value={f.question} autoFocus
            onChange={e => setF({ ...f, question: e.target.value })}
            placeholder="如：67元怎么退？退到哪里？" />
        </div>
        <div className="field">
          <label>标准答复</label>
          <textarea className="input" rows={8} value={f.answer}
            onChange={e => setF({ ...f, answer: e.target.value })}
            placeholder="直接写客服该怎么回，AI 会照着这个口径答" />
          <div className="small muted" style={{ marginTop: 6 }}>
            AI 会优先照搬这里的原话，所以写成可以直接发给客户的说法最好。
          </div>
        </div>
        <label className="row small" style={{ gap: 6, cursor: 'pointer', marginBottom: 8 }}>
          <input type="checkbox" checked={f.voice} onChange={e => setF({ ...f, voice: e.target.checked })} />
          <span>用语音回复：AI 用这条回答、且超过 20 字时，转成语音发给客户（客户打字也一样）</span>
        </label>
        <div className="err">{err}</div>
        <div className="row" style={{ justifyContent: 'flex-end', marginTop: 8 }}>
          <button className="btn" onClick={onClose}>取消</button>
          <button className="btn btn-primary" onClick={save} disabled={busy}>保存</button>
        </div>
      </div>
    </div>
  )
}

// ============ 图片/视频/文件素材 ============
const PRESET_CATEGORIES = ['产品图', '权益素材', '教程']

function Media() {
  const [list, setList] = useState([])
  const [err, setErr] = useState('')
  const [uploading, setUploading] = useState(false)
  const [progress, setProgress] = useState(0)
  const [picking, setPicking] = useState(null)   // 选中文件后弹出的填写框
  const fileRef = useRef(null)
  const [activeCat, setActiveCat] = useState('')

  const load = () => api.listMedia().then(setList).catch(e => setErr(e.message))
  useEffect(() => { load() }, [])

  // 预设分类 + 已有数据里出现过的自定义分类
  const categories = [...new Set([...PRESET_CATEGORIES, ...list.map(m => m.category).filter(Boolean)])]
  const counts = list.reduce((a, m) => ({ ...a, [m.category || '未分类']: (a[m.category || '未分类'] || 0) + 1 }), {})
  const shown = activeCat
    ? list.filter(m => (m.category || '未分类') === activeCat)
    : list
  // 按分类分组展示，未分类排最后
  const groups = shown.reduce((a, m) => {
    const k = m.category || '未分类'
    ;(a[k] = a[k] || []).push(m)
    return a
  }, {})
  const groupNames = Object.keys(groups).sort((a, b) =>
    a === '未分类' ? 1 : b === '未分类' ? -1 : a.localeCompare(b, 'zh'))

  function choose(e) {
    const file = e.target.files?.[0]
    e.target.value = ''
    if (!file) return
    try {
      const info = libraryFileType(file)
      setErr('')
      setPicking({ file, ...info, title: file.name.replace(/\.[^.]+$/, ''), category: activeCat && activeCat !== '未分类' ? activeCat : PRESET_CATEGORIES[0] })
    } catch (e) { setErr(e.message) }
  }

  async function doUpload() {
    const { file, title, category } = picking
    if (!title.trim()) { setErr('请填名称'); return }
    setUploading(true); setProgress(0); setErr('')
    // 结果用弹窗告知：运营传大视频时常切去别的页面，页内提示那时已经看不见了（弹窗挂在 Layout，切页面也能看到）
    try {
      await api.uploadMedia({ file, title: title.trim(), category: category.trim() }, setProgress)
      setPicking(null)
      await load()
      alertBox(`「${title.trim()}」上传成功`)
    } catch (e) {
      setErr(e.message)
      alertBox(`「${title.trim()}」上传失败：${e.message}`)
    } finally { setUploading(false) }
  }

  // 刷新/关闭页面会直接掐断上传，之前三次上传就是这样没了还没有任何提示
  useEffect(() => {
    if (!uploading) return
    const warn = e => { e.preventDefault(); e.returnValue = '' }
    window.addEventListener('beforeunload', warn)
    return () => window.removeEventListener('beforeunload', warn)
  }, [uploading])

  async function del(m) {
    if (!(await confirmBox(`确认删除「${m.title}」？`))) return
    try { await api.deleteMedia(m.id); load() } catch (e) { alertBox(e.message) }
  }

  async function move(m, category) {
    try { await api.updateMedia({ id: m.id, category }); load() } catch (e) { alertBox(e.message) }
  }

  return (
    <div className="card" style={{ padding: 20 }}>
      <div className="spread" style={{ marginBottom: 14 }}>
        <div className="row">
          <strong>图片 / 视频 / 文件素材</strong>
          <span className="tag">{list.length} 个</span>
        </div>
        <div>
          <input ref={fileRef} type="file" accept={`image/*,video/mp4,${DOCUMENT_ACCEPT}`} onChange={choose} style={{ display: 'none' }} />
          <button className="btn btn-primary btn-sm" disabled={uploading}
            onClick={() => fileRef.current?.click()}>
            {uploading ? `上传中 ${progress}%` : '+ 上传素材'}
          </button>
        </div>
      </div>

      {/* 分类筛选 */}
      <div className="row" style={{ gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
        <button className="btn btn-sm" onClick={() => setActiveCat('')}
          style={!activeCat ? { background: 'var(--brand)', borderColor: 'var(--brand)', color: '#fff' } : {}}>
          全部 {list.length}
        </button>
        {Object.keys(counts).sort((a, b) => a === '未分类' ? 1 : b === '未分类' ? -1 : a.localeCompare(b, 'zh')).map(c => (
          <button key={c} className="btn btn-sm" onClick={() => setActiveCat(c)}
            style={activeCat === c ? { background: 'var(--brand)', borderColor: 'var(--brand)', color: '#fff' } : {}}>
            {c} {counts[c]}
          </button>
        ))}
      </div>

      {err && <div className="err">{err}</div>}

      {list.length === 0 ? (
        <div className="empty">暂无素材。上传产品图、教程视频、Word 或 PDF 文件后，客服可在工作台一键发给客户。</div>
      ) : groupNames.map(g => (
        <div key={g} style={{ marginBottom: 22 }}>
          {!activeCat && (
            <div className="row" style={{ gap: 8, marginBottom: 10 }}>
              <strong style={{ fontSize: 14 }}>{g}</strong>
              <span className="small muted">{groups[g].length} 个</span>
            </div>
          )}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(190px, 1fr))', gap: 14 }}>
            {groups[g].map(m => (
              <div key={m.id} className="card" style={{ padding: 10, overflow: 'hidden' }}>
                {m.kind === 'file' ? (
                  <DocumentCard filename={documentDownloadName(m)} size={m.size_bytes}
                    href={serverUrl(`/kb-media/${m.filename}`)} download={documentDownloadName(m)} />
                ) : m.kind === 'video' ? (
                  <video src={serverUrl(`/kb-media/${m.filename}`)} controls preload="metadata"
                    style={{ width: '100%', height: 120, objectFit: 'cover', borderRadius: 8, background: '#000' }} />
                ) : (
                  <a href={serverUrl(`/kb-media/${m.filename}`)} target="_blank" rel="noreferrer">
                    <img src={serverUrl(`/kb-media/${m.filename}`)} alt={m.title}
                      style={{ width: '100%', height: 120, objectFit: 'cover', borderRadius: 8, background: 'var(--hover)' }} />
                  </a>
                )}
                <div className="row" style={{ gap: 5, marginTop: 8 }}>
                  {m.kind !== 'image' && <span className="tag" style={{ flexShrink: 0 }}>{m.kind === 'file' ? '文件' : '视频'}</span>}
                  <span style={{ fontSize: 13, fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {m.title}
                  </span>
                </div>
                <div className="spread" style={{ marginTop: 6 }}>
                  <select className="input" style={{ height: 26, fontSize: 12, padding: '0 4px', maxWidth: 108 }}
                    value={m.category || ''} onChange={e => move(m, e.target.value)}>
                    <option value="">未分类</option>
                    {categories.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                  <button className="btn-link small" style={{ color: 'var(--danger)' }} onClick={() => del(m)}>删除</button>
                </div>
                <label className="row small" style={{ marginTop: 6, gap: 6, cursor: 'pointer' }}>
                  <input type="checkbox" checked={!!m.ai_enabled}
                    onChange={async e => {
                      try { await api.updateMedia({ id: m.id, ai_enabled: e.target.checked }); load() }
                      catch (e) { alertBox(e.message) }
                    }} />
                  <span style={{ color: m.ai_enabled ? 'var(--brand)' : 'var(--muted)' }}>允许 AI 自动发</span>
                </label>
                {m.ai_enabled && <HintField media={m} onSaved={load} />}
              </div>
            ))}
          </div>
        </div>
      ))}

      <div className="small muted" style={{ marginTop: 6, padding: 10, background: '#fffbeb', borderRadius: 8, color: '#b45309' }}>
        图片最大 5MB，mp4 视频最大 10MB，Word（.doc、.docx）/ PDF（.pdf）最大 20MB。文件作为附件发送，不自动解析正文。
        勾选「允许 AI 自动发」后，AI 会在你描述的时机自动发给客户；未勾选的只能由客服手动发。
        AI 一次最多发一个。企业微信素材有效期 3 天，系统会在过期后自动重新上传。
      </div>

      {picking && (
        <MediaUploadModal
          picking={picking} setPicking={setPicking} categories={categories}
          busy={uploading} progress={progress} err={err} onSubmit={doUpload}
          onClose={() => { setPicking(null); setErr('') }} />
      )}
    </div>
  )
}

// 「什么时候发」这句话会原样进 AI 的提示词，所以要能随时改
function HintField({ media, onSaved }) {
  const [val, setVal] = useState(media.ai_hint || '')
  const [state, setState] = useState('')   // '' | saving | saved | 错误文案

  // 别的地方改了这条素材（比如换分类后重新加载），同步过来；正在编辑时不打断
  useEffect(() => { setVal(media.ai_hint || '') }, [media.ai_hint])

  async function save() {
    const next = val.trim()
    if (next === (media.ai_hint || '')) { setState(''); return }
    setState('saving')
    try {
      await api.updateMedia({ id: media.id, ai_hint: next })
      setState('saved')
      setTimeout(() => setState(''), 1600)
      onSaved?.()
    } catch (e) { setState(e.message) }
  }

  const empty = !val.trim()
  return (
    <div style={{ marginTop: 5 }}>
      <div className="row small" style={{ gap: 5, marginBottom: 3 }}>
        <span className="muted">什么时候发</span>
        {state === 'saving' && <span className="muted">保存中…</span>}
        {state === 'saved' && <span style={{ color: 'var(--ok)' }}>已保存</span>}
        {state && !['saving', 'saved'].includes(state) && <span style={{ color: 'var(--danger)' }}>{state}</span>}
      </div>
      <textarea
        className="input" rows={2} value={val}
        onChange={e => setVal(e.target.value)}
        onBlur={save}
        onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); e.target.blur() } }}
        placeholder="例：客户询问有哪些产品或套餐时"
        style={{
          fontSize: 12, lineHeight: 1.5, padding: '5px 7px', resize: 'vertical',
          borderColor: empty ? 'var(--danger)' : undefined,
        }} />
      {empty && (
        <div className="small" style={{ color: 'var(--danger)', marginTop: 2, lineHeight: 1.4 }}>
          没填时机，AI 不知道什么时候该发
        </div>
      )}
    </div>
  )
}

function MediaUploadModal({ picking, setPicking, categories, busy, progress, err, onSubmit, onClose }) {
  const [newCat, setNewCat] = useState(false)
  const sizeMB = (picking.file.size / 1024 / 1024).toFixed(1)
  return (
    <div className="modal-bg" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={{ maxWidth: 460 }}>
        <h2>上传{picking.label}</h2>
        <div className="small muted" style={{ marginBottom: 14 }}>
          {picking.file.name} · {sizeMB}MB
        </div>
        <div className="field">
          <label>素材名称</label>
          <input className="input" value={picking.title} autoFocus
            onChange={e => setPicking({ ...picking, title: e.target.value })}
            placeholder="客服和 AI 都按这个名字查找" />
        </div>
        <div className="field">
          <label>分类</label>
          {newCat ? (
            <div className="row" style={{ gap: 6 }}>
              <input className="input" autoFocus value={picking.category}
                onChange={e => setPicking({ ...picking, category: e.target.value })}
                placeholder="输入新分类名" />
              <button className="btn btn-sm" onClick={() => { setNewCat(false); setPicking({ ...picking, category: categories[0] || '' }) }}>取消</button>
            </div>
          ) : (
            <div className="row" style={{ gap: 6 }}>
              <select className="input" value={picking.category}
                onChange={e => setPicking({ ...picking, category: e.target.value })}>
                <option value="">未分类</option>
                {categories.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
              <button className="btn btn-sm" onClick={() => { setNewCat(true); setPicking({ ...picking, category: '' }) }}>+ 新分类</button>
            </div>
          )}
        </div>
        {busy && (
          <div style={{ marginTop: 6 }}>
            <div style={{ height: 8, background: 'var(--line)', borderRadius: 4, overflow: 'hidden' }}>
              <div style={{ width: `${progress}%`, height: '100%', background: 'var(--brand)', transition: 'width .3s' }} />
            </div>
            <div className="small muted" style={{ marginTop: 6 }}>
              {progress < 100
                ? `已上传 ${progress}%（${(picking.file.size * progress / 100 / 1024 / 1024).toFixed(1)}/${sizeMB}MB），可以切去别的页面，传完会弹窗提示；不要刷新或关闭页面`
                : '已传完，服务器处理中…'}
            </div>
          </div>
        )}
        {err && <div className="err">{err}</div>}
        <div className="row" style={{ justifyContent: 'flex-end', marginTop: 8 }}>
          <button className="btn" onClick={onClose} disabled={busy}>取消</button>
          <button className="btn btn-primary" onClick={onSubmit} disabled={busy}>
            {busy ? `上传中 ${progress}%` : '上传'}
          </button>
        </div>
      </div>
    </div>
  )
}

function SkillDocs() {
  const [list, setList] = useState([])
  const [err, setErr] = useState('')
  const [edit, setEdit] = useState(null)   // {id,title,content}
  const [busy, setBusy] = useState(false)
  const load = () => api.listKbDocs({ limit: 200 }).then(setList).catch(e => setErr(e.message))
  useEffect(() => { load() }, [])
  async function toggle(d) {
    await api.updateKbDoc(d.id, { enabled: !d.enabled }).catch(e => setErr(e.message))
    load()
  }
  async function openEdit(d) {
    const full = await api.getKbDoc(d.id).catch(e => { setErr(e.message); return null })
    if (full) setEdit(full)
  }
  async function saveEdit() {
    setBusy(true)
    try {
      await api.updateKbDoc(edit.id, { content: edit.content })
      setEdit(null); load()
    } catch (e) { setErr(e.message) } finally { setBusy(false) }
  }
  return (
    <section>
      <div className="muted small" style={{ marginBottom: 10 }}>
        这里是框架知识库的「文档」层：skill 块、模式包、规则文档都在这里；启用的文档会随 prompt 注入。
      </div>
      {err && <div className="err small" style={{ marginBottom: 8 }}>{err}</div>}
      <div style={{ display: 'grid', gap: 8 }}>
        {list.map(d => (
          <div key={d.id} className="card" style={{ padding: 10 }}>
            <div className="row" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <b>{d.title || '(无标题)'}</b>
                <span className="muted small" style={{ marginLeft: 8 }}>{d.source || '—'} · {(d.created_at || '').slice(0, 10)}</span>
                {d.mode && <span className="tag" style={{ marginLeft: 8, background: d.mode === '常驻' ? '#166534' : d.mode === '按需命中' ? 'var(--hover)' : '#7f1d1d', color: d.mode === '按需命中' ? 'inherit' : '#fff' }}>{d.mode}</span>}
              </div>
              <div className="row" style={{ gap: 6 }}>
                <button className="btn btn-sm" onClick={() => openEdit(d)}>编辑</button>
                <button className="btn btn-sm" onClick={() => toggle(d)}>{d.enabled ? '停用' : '启用'}</button>
              </div>
            </div>
            <div className="muted small" style={{ marginTop: 6 }}>{(d.preview || '').replace(/\n/g, ' ').slice(0, 120)}…</div>
          </div>
        ))}
        {!list.length && <div className="muted">还没有文档</div>}
      </div>
      {edit && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50 }}>
          <div className="card" style={{ width: 'min(900px, 92vw)', maxHeight: '86vh', overflow: 'auto', padding: 18 }}>
            <div className="spread" style={{ marginBottom: 10 }}>
              <b>{edit.title}</b>
              <span className="muted small">{edit.content.length} 字</span>
            </div>
            <textarea className="input" rows={22} value={edit.content} onChange={e => setEdit({ ...edit, content: e.target.value })}
              style={{ width: '100%', fontFamily: 'ui-monospace, monospace', fontSize: 12.5, lineHeight: 1.6 }} />
            <div className="row" style={{ gap: 10, marginTop: 10, justifyContent: 'flex-end' }}>
              <button className="btn btn-sm" onClick={() => setEdit(null)}>取消</button>
              <button className="btn btn-primary btn-sm" disabled={busy} onClick={saveEdit}>{busy ? '保存中…' : '保存'}</button>
            </div>
          </div>
        </div>
      )}
    </section>
  )
}
